import { config } from '@fortawesome/fontawesome-svg-core'

import '@fortawesome/fontawesome-svg-core/styles.css'
config.autoAddCss = false

import { useEffect, useRef, useState } from 'react';
import { faChevronDown as fasChevronDown } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Checkers from '../../../helpers/class/Checkers';
import ContactIcons from '../partials/ContactIcons';
import DropdownArrow from '../partials/DropdownArrow';
import SearchIcon  from '../partials/SearchIcon'
import {useSelector} from "react-redux";
import {fetchBuilderSettingByKey, scrollToAnchor} from "../../../helpers/MethodHelper";
import {current} from "immer";
import Link from "next/link";
import LanguageSwitcher from '../partials/LanguageSwitcher';

export default function HeaderMenu ( props ) {

  const menuItemDisableWrap = props.hasOwnProperty('menuItemDisableWrap') ? props.menuItemDisableWrap : false

  const handleHide = props.hasOwnProperty('handleHide') ? props.handleHide : false

  const textWrapClass = menuItemDisableWrap ? '' : 'text-nowrap'

  const showMenuItems = useSelector(
      state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_header_show_menu_items')
  );

  const [ expandedKey, setExpandedKey ] = useState( null );


  const elRefs = useRef([]);

  useEffect(() => {
    if (document !== undefined && elRefs !== undefined) {
      for (const elRef of elRefs.current) {
        elRef !== undefined && elRef.addEventListener('mouseenter', function () {
          this.children[0].classList.add('show');
          this.children[0].setAttribute('aria-extended', 'true');
          this.children[1].classList.add('show');
        })
        elRef !== undefined && elRef.addEventListener('mouseleave', function () {
          this.children[0].classList.remove('show');
          this.children[0].setAttribute('aria-extended', 'false');
          this.children[1].classList.remove('show');
        })
      }

    }
  }, [elRefs]);

  const topLevelHref = (menu, loggiaUrl) => {
    if (menu.hasOwnProperty('redirectUrl')) {
      return menu.redirectUrl
    }

    // A category that is shown on the home page (its url slug is an anchor) links to its section, like on the Lodge
    // site (/#category121), instead of opening the category page.
    if (typeof menu.urlSlug === 'string' && menu.urlSlug.startsWith('#') && typeof loggiaUrl === 'string' && loggiaUrl.startsWith('category/')) {
      const anchor = menu.urlSlug.length > 1 ? menu.urlSlug : '#category' + loggiaUrl.split('/')[1]
      return props.referer + anchor
    }

    return loggiaUrl != null ? props.referer + loggiaUrl : menu.urlSlug != null ? props.referer + menu.urlSlug : '#'
  }

  const topLevelHrefBlank = (menu, loggiaUrl) => {
    if (menu.hasOwnProperty('redirectUrl')) {
      return true
    }

    return false
  }

  const handleMenuLinkClick = (href) => (e) => {
    if (!Checkers.isValidString(href)) {
      if (handleHide != undefined) handleHide()
      return
    }

    const hashIndex = href.indexOf('#')
    if (hashIndex === -1) {
      if (handleHide != undefined) handleHide()
      return
    }

    const hash = href.slice(hashIndex + 1)
    if (hash.length === 0) {
      if (handleHide != undefined) handleHide()
      return
    }

    const path = href.slice(0, hashIndex)
    const stripTrailingSlash = (u) => u.replace(/\/+$/, '')
    const isSamePage = typeof window !== 'undefined' &&
        (path === '' ||
            stripTrailingSlash(path) === stripTrailingSlash(window.location.pathname) ||
            stripTrailingSlash(path) === stripTrailingSlash(window.location.origin + window.location.pathname))
    if (!isSamePage) {
      if (handleHide != undefined) handleHide()
      return
    }

    e.preventDefault()

    if (handleHide != undefined) {
      handleHide()
      let attempts = 0
      const tryScroll = () => {
        if (document.body.style.overflow === 'hidden' && attempts < 40) {
          attempts += 1
          requestAnimationFrame(tryScroll)
          return
        }
        scrollToAnchor(hash, 'auto')
      }
      requestAnimationFrame(tryScroll)
    } else {
      scrollToAnchor(hash)
    }
  }

  return (
      <>
        {
            showMenuItems == '1' && Checkers.isValidArray(props.menu) &&
            props.menu.map((menu, key) => {
              let loggiaUrl = menu.loggiaUrl;
              if (Checkers.isValidString(loggiaUrl) && loggiaUrl.startsWith('/')) {
                loggiaUrl = loggiaUrl.substring(1);
              }

              let special_class = ''
              if (menu.special_class != undefined && menu.special_class.length > 0) {
                special_class = menu.special_class
              }

              // The "Book" menu item follows the search bar destination (click handler in Header). Its title is
              // translated (Book / Κράτηση / Buchen...), so it is recognised by what it is instead: a menu item
              // styled as a button that links to the properties list or to a booking engine. "Properties" also
              // links to /properties/all but is not a button. An English "Book..." title still counts.
              const menuLinks = [menu.urlSlug, menu.loggiaUrl, menu.redirectUrl].filter((link) => Checkers.isValidString(link))
              const isBookItem = !Checkers.isValidArray(menu.entries) && (
                  (Checkers.isValidString(menu.title) && /^\s*book/i.test(menu.title)) ||
                  (/(^|\s)btn(\s|$)/.test(special_class) && menuLinks.some((link) => /properties\/all|reserve-online\.net/.test(link)))
              )
              if (isBookItem) {
                special_class += ' header-book-link'
              }

              return (
                  menu.title != null ?
                      <li
                          key={key}
                          ref={Checkers.isValidArray(menu.entries) ? (el) => {
                            elRefs.current[key] = el
                          } : undefined}
                          className={menu.entries != null ? 'nav-item dropdown cursor-pointer' : 'nav-item'}
                      >
                        {
                          menu.hasOwnProperty('force_reload') && menu.force_reload ?
                              <>
                                <a aria-current="page"
                                   href={topLevelHref(menu, loggiaUrl)}
                                   className={special_class + " " + (menu.entries != null ? 'd-flex nav-link dropdown-toggle ' + textWrapClass : 'nav-link test-111 ' + textWrapClass)}>
                                  {menu.title}
                                  {Checkers.isValidArray(menu.entries) &&
                                      <FontAwesomeIcon icon={fasChevronDown} className="m-l-5 align-self-center"
                                                       style={{fontSize: '10.5px'}}/>
                                  }
                                </a>
                              </>
                              :
                              <>
                                {
                                  topLevelHrefBlank(menu, loggiaUrl) ?
                                      <>
                                        <Link target={"_blank"}
                                              href={topLevelHref(menu, loggiaUrl)}
                                        >
                                          <a className={special_class + " " + (menu.entries != null ? 'd-flex nav-link dropdown-toggle ' + textWrapClass : 'nav-link test-222 ' + textWrapClass)}
                                             aria-current="page"
                                             onClick={handleMenuLinkClick(topLevelHref(menu, loggiaUrl))}
                                             rel={"noreferrer noopener"}>
                                            {menu.title}
                                            {Checkers.isValidArray(menu.entries) &&
                                                <FontAwesomeIcon icon={fasChevronDown} className="m-l-5 align-self-center"
                                                                 style={{fontSize: '10.5px'}}/>
                                            }
                                          </a>
                                        </Link>
                                      </>
                                      :
                                      <>
                                        <Link href={topLevelHref(menu, loggiaUrl)}>
                                          <a aria-current="page"
                                             onClick={handleMenuLinkClick(topLevelHref(menu, loggiaUrl))}
                                             className={special_class + " " + (menu.entries != null ? 'd-flex nav-link dropdown-toggle ' + textWrapClass : 'nav-link test-44444 ' + textWrapClass)}>
                                            {menu.title}
                                            {Checkers.isValidArray(menu.entries) &&
                                                <FontAwesomeIcon icon={fasChevronDown} className="m-l-5 align-self-center"
                                                                 style={{fontSize: '10.5px'}}
                                                                 onClick={props.modalDropdownClass != null ? (e) => {
                                                                   e.preventDefault()
                                                                   e.stopPropagation()
                                                                   setExpandedKey(expandedKey === key ? null : key)
                                                                 } : undefined}/>
                                            }
                                          </a>
                                        </Link>
                                      </>
                                }
                              </>
                        }
                        {Checkers.isValidArray(menu.entries) &&
                            <ul className={(props.modalDropdownClass != null ? 'dropdown-menu dropdown-article-menu\ ' + props.modalDropdownClass : 'dropdown-menu dropdown-article-menu shadow ' + (menu.entries.length>10 ? "megamenu" : "")) + (expandedKey === key ? ' show' : '')}>
                              {
                                  props.modalDropdownClass == null &&
                                  <DropdownArrow/>
                              }
                              {
                                menu.entries.map((entry, key) => {
                                  let loggiaUrl = entry.loggiaUrl;
                                  if (Checkers.isValidString(loggiaUrl) && loggiaUrl.startsWith('/')) {
                                    loggiaUrl = loggiaUrl.substring(1);
                                  }

                                  const entryHref = Checkers.isValidString(entry.redirectUrl) ?
                                      entry.redirectUrl
                                      :
                                      loggiaUrl != null ?
                                          props.referer + loggiaUrl
                                          :
                                          entry.urlSlug != null ? props.referer + entry.urlSlug : '#'

                                  return (
                                      <li
                                          key={key}
                                          className={key == 0 ? 'dropdown-ul-item mt-20px' : 'dropdown-ul-item mt-3'}
                                      >
                                        <Link href={entryHref} >
                                          <a  className={"dropdown-item text-wrap "} onClick={handleMenuLinkClick(entryHref)}>
                                            {entry.title}
                                          </a>
                                        </Link>
                                      </li>
                                  )
                                })
                              }
                            </ul>
                        }
                      </li>
                      : ''
              )
            })
        }
        {
            <ContactIcons contactIcons={props.contactIcons}/>
        }
        {
          props.partials !== null && props.partials.hasOwnProperty('book') === true ?
              props.partials.book != null && props.headerPartialBook == true ?
                  <li className="nav-item header-book-partial" dangerouslySetInnerHTML={{__html: props.partials.book.title}}/>
                  : ''
              : ''
        }
        {
            // header types with a slot next to the search icon render the languages there (hideLanguages),
            // so they stay outside the burger menu
            !props.hideLanguages &&
            <LanguageSwitcher partials={props.partials} modalDropdownClass={props.modalDropdownClass} handleHide={handleHide}/>
        }
      </>
  )
}
